export const GVMessageTable = {
  gv_busy:
    "Er is al een zoekopdracht bezig, wacht a.u.b. tot deze klaar is of herlaad de pagina.",
  gv_create_fail:
    "Het starten van de zoekopdracht is mislukt, probeer het later opnieuw",
  gv_create_bad_response:
    "Het starten van de zoekopdracht is mislukt, probeer het later opnieuw",
  gv_invalid_state:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
  gv_session_not_set:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
  gv_engine_fail:
    "Het starten van de zoekopdracht is mislukt, probeer het later opnieuw",
  gv_progress_null: "",
  gv_results_null: "",
  gv_parse_result:
    "Er is een probleem opgetreden bij het verwerken van de resultaten.",
  gv_no_origin: "U heeft geen vertreklocatie ingevuld.",
  gv_no_dest: "U heeft geen aankomstlocatie ingevuld.",
  gv_invalid_providers:
    "Er is een probleem opgetreden bij het verwerken van de resultaten.",
  gv_error_modal_title: "",
  gv_success:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
  gv_invalid_home:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
  gv_no_legs:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
  gv_past_date: "U heeft een begindatum in het verleden ingevuld",
  gv_leg_order:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
  gv_bad_origin: "De vertrekplaats die u heeft ingevoerd wordt niet herkend.",
  gv_bad_dest: "De bestemming die u heeft ingevoerd wordt niet herkend.",
  gv_same_route: "U kunt niet van een luchthaven naar zichzelf vliegen",
  gv_inv_adults: "U heeft een ongeldig aantal volwassenen ingevuld",
  gv_inv_children: "U heeft een ongeldig aantal kinderen ingevuld",
  gv_inv_infants: "U heeft een ongeldig aantal babies ingevuld",
  gv_inv_passengers: "U heeft een ongeldig aantal passagiers ingevuld",
  gv_too_many_babies:
    "Er moeten op zijn minst even veel volwassenen als babies reizen",
  gv_bad_request:
    "Er is een probleem opgetreden in de webpagina, herlaad deze a.u.b.",
};
